import HttpService from "~/Scripts/services/httpService";

const instance = new HttpService( "umbraco/api/RegistrationApi/" );

export const webAccountUserTypes = () => instance.get( "ListWebAccountUserTypeParents" );

export const jobTypes = ( userTypeParentId ) => instance.get( `ListJobTypes?userTypeParentId=${userTypeParentId}` );

export const register = ( account, orgMetaData, marketingOptIn ) => instance.post( "Register", { account, orgMetaData, marketingOptIn } );
